import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { vendorRepository } from '@webapp/modules/vendor/data-access/repositories/VendorRepository'
import { VendorTypes } from '@webapp/modules/vendor/entities/enums/VendorTypeEnum'
import {
  CREDIT_CARD_PROVIDER_OPTIONS_QUERY_KEY,
  type CreditCardProviderOption,
} from '@webapp/platform/banking'

interface CreateCreditCardProviderMutationVariables {
  name: string
}

export const useMutateCreateCreditCardProvider = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading, isError } = useMutation<
    CreditCardProviderOption,
    RepoError,
    CreateCreditCardProviderMutationVariables
  >({
    mutationFn: async ({ name }) => {
      const { data } = await vendorRepository.createVendor({
        name,
        email: [],
        type: VendorTypes.CREDIT_CARD_PROVIDER,
      })

      return { id: data.id, name: data.name }
    },

    onSuccess: (provider) => {
      queryClient.setQueryData<CreditCardProviderOption[]>(
        CREDIT_CARD_PROVIDER_OPTIONS_QUERY_KEY,
        (options) => [...(options ?? []), provider]
      )
    },
  })

  return {
    createProvider: mutateAsync,
    isSaving: isLoading,
    hasCreateFailed: isError,
  }
}
